export const CONDITION_TYPE_ALL = 0
export const CONDITION_TYPE_AND = 1
export const CONDITION_TYPE_OR = 2

export const STATISTICS_VALUETYPES_MEAN = 0
export const STATISTICS_VALUETYPES_SUM = 1
export const STATISTICS_VALUETYPES_COUNT = 2

export const STATISTICS_DATATYPES_DAILY = 0
export const STATISTICS_DATATYPES_FREQ_DISTR = 1
export const STATISTICS_DATATYPES_SUM = 2
export const STATISTICS_DATATYPES_XY = 3

export const STATISTICS_CHARTTYPES_LINE = 0
export const STATISTICS_CHARTTYPES_LINE_FILLED = 1
export const STATISTICS_CHARTTYPES_BARS = 2
export const STATISTICS_CHARTTYPES_SCATTER = 3
export const STATISTICS_CHARTTYPES_PIE = 4

export const STATISTICS_STORAGE_TYPE_TIMED = 0
export const STATISTICS_STORAGE_TYPE_FREQ_DISTR = 1
export const STATISTICS_STORAGE_TYPE_PER_DATA = 2

export const CONDITION_OPERATOR_EQUAL = 0
export const CONDITION_OPERATOR_UNEQUAL = 1
export const CONDITION_OPERATOR_GREATER = 2
export const CONDITION_OPERATOR_LESS = 3